import React, { useEffect, useMemo, useState, useCallback, useRef } from 'react';
import { OverlayBoundary } from '../../editor/EditorOverlay/styles';
import { HintTooltip, useIsMobile } from '@brg/ui';
import MultipleColumn from './components/MultipleColumn';
import { createPortal } from 'react-dom';
import { AddTextBottom, AddTextCaption, AddTextCenter, AddTextTop, PrintImageWrap, TwoPicturesPrintImageWrap } from '../EditorToolbar/styles';
import useLocalization from '../../../../../hooks/useLocalization';
import { CaptionBlock } from '../../postblocks/coloredblock';
import { CaptionMarkdownText } from '../../postblocks/whitepostblock';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import formatLinks from '../../../../../utilites/formatLinks';
import { MobileLoaderWrapper } from '../../addimageblock';
import { LoaderModal } from '../../../../modals/LoaderModal';
import { LoaderProgressBar } from '../../postblocks/imagecaptionblock';
import { GeneralEditorOverlay } from '../EditorOverlayNew/GeneralEditorOverlay';
import { fixUnsizedImages, isUnsizedImages } from '../../../../../utilites/fixUnsizedImages';
import useCommonProps from '../../../../../hooks/useCommonProps';
import { getPostWithoutOriginals } from '../../../../../utilites/getPostWithoutOriginals';
import CommentViewController from '../../../comments';
var TwoPicturesBlock = function (props) {
    var post = props.post, srcList = props.srcList, isEditable = props.isEditable, dragHandleProps = props.dragHandleProps, onChange = props.onChange, onSlideTextChange = props.onSlideTextChange, onRatioError = props.onRatioError, controlsPlacer = props.controlsPlacer, onCaptionEdit = props.onCaptionEdit, colorStyle = props.colorStyle, onChangeImage = props.onChangeImage, fileRef = props.fileRef, isTwoPicturesLoading = props.isLoading;
    var t = useLocalization().t;
    var _a = useState(false), editingText = _a[0], setEditingText = _a[1];
    var _b = useState(null), position = _b[0], setPosition = _b[1];
    var _c = useState(null), editedSlide = _c[0], setEditedSlide = _c[1];
    var editedSlideRef = useRef(null);
    var _d = useState([]), listWithSizes = _d[0], setListWithSizes = _d[1];
    var _e = useState(false), checkSizeLoad = _e[0], setCheckSizeLoad = _e[1];
    var _f = useCommonProps(), isPrint = _f.isPrint, printBg = _f.printBg, isFeed = _f.isFeed, printType = _f.printType;
    useEffect(function () {
        editedSlideRef.current = editedSlide;
    }, [editedSlide]);
    var isMobile = useIsMobile();
    var isLoading = useMemo(function () { return ((post === null || post === void 0 ? void 0 : post.postId) === 'loading' || (post === null || post === void 0 ? void 0 : post.postId) === 'updating' || isTwoPicturesLoading) && !checkSizeLoad; }, [post, isTwoPicturesLoading, checkSizeLoad]);
    var srcListFinal = useMemo(function () { var _a; return (((_a = (isPrint ? getPostWithoutOriginals(post) : post)) === null || _a === void 0 ? void 0 : _a.attachments) || srcList); }, [post, srcList, isPrint]);
    // const commentController = useMemo(() => {
    //   return (
    //     <CommentViewController postEntityId={post?.postId} />
    //   )
    // } , [post])
    var captionMaxLength = 100;
    useEffect(function () {
        if (isUnsizedImages(srcListFinal)) {
            setCheckSizeLoad(true);
            fixUnsizedImages(srcListFinal || [])
                .then(function (r) {
                setListWithSizes(r || []);
                setCheckSizeLoad(false);
            });
        }
        else {
            setListWithSizes(srcListFinal);
        }
    }, [srcListFinal]);
    var handleButtonClick = useCallback(function (position) {
        var currentEditedSlide = editedSlideRef.current;
        if (!currentEditedSlide) {
            setEditingText(true);
            return;
        }
        onSlideTextChange(currentEditedSlide, 'updatePosition', position);
        setPosition(position);
    }, [editedSlide, onSlideTextChange, srcListFinal]);
    var handleSlideEditToggle = function (id, value, textPosition) {
        if (value === true) {
            editedSlideRef.current = id;
            setEditedSlide(id);
            setPosition(textPosition || 'bottom');
        }
        else {
            editedSlideRef.current = null;
            setEditedSlide(null);
            setPosition(null);
        }
    };
    var controls = useMemo(function () {
        if (controlsPlacer) {
            return createPortal(React.createElement(React.Fragment, null,
                !!editedSlide && (React.createElement(React.Fragment, null,
                    React.createElement(HintTooltip, { z: 4, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_top') },
                        React.createElement(AddTextTop, { active: position === 'top', onClick: function () { return handleButtonClick('top'); } })),
                    React.createElement(HintTooltip, { z: 3, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_center') },
                        React.createElement(AddTextCenter, { active: position === 'center', onClick: function () { return handleButtonClick('center'); } })),
                    React.createElement(HintTooltip, { z: 2, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_bottom') },
                        React.createElement(AddTextBottom, { active: position === 'bottom', onClick: function () { return handleButtonClick('bottom'); } })))),
                !editedSlide && (React.createElement(HintTooltip, { z: 1, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_under') },
                    React.createElement(AddTextCaption, { active: position === 'caption-bottom', onClick: onCaptionEdit })))), controlsPlacer);
        }
    }, [controlsPlacer, position, editedSlide, handleButtonClick, t, onCaptionEdit]);
    if (!(listWithSizes === null || listWithSizes === void 0 ? void 0 : listWithSizes.length) && !isEditable) {
        return null;
    }
    if (isPrint && printType !== 'magazine')
        return React.createElement(TwoPicturesPrintImageWrap, { style: { backgroundColor: printBg }, withoutCaption: !(post === null || post === void 0 ? void 0 : post.caption), isPrint: true },
            React.createElement(MultipleColumn, { srcList: listWithSizes, isEditable: isEditable && !post, onChange: onChange, onSlideTextChange: onSlideTextChange, onRatioError: onRatioError, onSlideEditToggle: handleSlideEditToggle, position: position, editedSlide: editedSlide, onChangeImage: onChangeImage, captionMaxLength: captionMaxLength, fileRef: fileRef }),
            (post === null || post === void 0 ? void 0 : post.caption) && (React.createElement(CaptionBlock, { className: 'longread-caption-block', colorStyle: colorStyle },
                React.createElement(CaptionMarkdownText, { rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks(post === null || post === void 0 ? void 0 : post.caption)))));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { position: 'relative' } },
            isLoading && (React.createElement(React.Fragment, null, isMobile || (post === null || post === void 0 ? void 0 : post.postId) === 'updating' ? (React.createElement(MobileLoaderWrapper, { colorStyle: colorStyle },
                React.createElement(LoaderModal, { placeholder: t('modal.loader.isLoading') }))) : (React.createElement(LoaderProgressBar, null)))),
            React.createElement(OverlayBoundary, { className: 'white-post-block', isLoadingPost: isLoading },
                React.createElement(GeneralEditorOverlay, { isEditable: isEditable, isLoading: isLoading, withoutDrag: isFeed, post: post, dragHandleProps: dragHandleProps }),
                controls,
                React.createElement(MultipleColumn, { srcList: listWithSizes, isEditable: isEditable && !post, onChange: onChange, onSlideTextChange: onSlideTextChange, onRatioError: onRatioError, onSlideEditToggle: handleSlideEditToggle, position: position, editedSlide: editedSlide, onChangeImage: onChangeImage, captionMaxLength: captionMaxLength, fileRef: fileRef }))),
        (post === null || post === void 0 ? void 0 : post.caption) && (React.createElement(CaptionBlock, { className: 'longread-caption-block', colorStyle: colorStyle },
            React.createElement(CaptionMarkdownText, { rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks(post === null || post === void 0 ? void 0 : post.caption))))));
};
export default TwoPicturesBlock;
//# sourceMappingURL=TwoPicturesBlock.js.mapimport React, { useEffect, useMemo, useState, useCallback, useRef } from 'react';
import { OverlayBoundary } from '../../editor/EditorOverlay/styles';
import { HintTooltip, useIsMobile } from '@brg/ui';
import MultipleColumn from './components/MultipleColumn';
import { createPortal } from 'react-dom';
import { AddTextBottom, AddTextCaption, AddTextCenter, AddTextTop, PrintImageWrap, TwoPicturesPrintImageWrap } from '../EditorToolbar/styles';
import useLocalization from '../../../../../hooks/useLocalization';
import { CaptionBlock } from '../../postblocks/coloredblock';
import { CaptionMarkdownText } from '../../postblocks/whitepostblock';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import formatLinks from '../../../../../utilites/formatLinks';
import { MobileLoaderWrapper } from '../../addimageblock';
import { LoaderModal } from '../../../../modals/LoaderModal';
import { LoaderProgressBar } from '../../postblocks/imagecaptionblock';
import { GeneralEditorOverlay } from '../EditorOverlayNew/GeneralEditorOverlay';
import { fixUnsizedImages, isUnsizedImages } from '../../../../../utilites/fixUnsizedImages';
import useCommonProps from '../../../../../hooks/useCommonProps';
import { getPostWithoutOriginals } from '../../../../../utilites/getPostWithoutOriginals';
import CommentViewController from '../../../comments';
var TwoPicturesBlock = function (props) {
    var post = props.post, srcList = props.srcList, isEditable = props.isEditable, dragHandleProps = props.dragHandleProps, onChange = props.onChange, onSlideTextChange = props.onSlideTextChange, onRatioError = props.onRatioError, controlsPlacer = props.controlsPlacer, onCaptionEdit = props.onCaptionEdit, colorStyle = props.colorStyle, onChangeImage = props.onChangeImage, fileRef = props.fileRef, isTwoPicturesLoading = props.isLoading;
    var t = useLocalization().t;
    var _a = useState(false), editingText = _a[0], setEditingText = _a[1];
    var _b = useState(null), position = _b[0], setPosition = _b[1];
    var _c = useState(null), editedSlide = _c[0], setEditedSlide = _c[1];
    var editedSlideRef = useRef(null);
    var _d = useState([]), listWithSizes = _d[0], setListWithSizes = _d[1];
    var _e = useState(false), checkSizeLoad = _e[0], setCheckSizeLoad = _e[1];
    var _f = useCommonProps(), isPrint = _f.isPrint, printBg = _f.printBg, isFeed = _f.isFeed, printType = _f.printType;
    useEffect(function () {
        editedSlideRef.current = editedSlide;
    }, [editedSlide]);
    var isMobile = useIsMobile();
    var isLoading = useMemo(function () { return ((post === null || post === void 0 ? void 0 : post.postId) === 'loading' || (post === null || post === void 0 ? void 0 : post.postId) === 'updating' || isTwoPicturesLoading) && !checkSizeLoad; }, [post, isTwoPicturesLoading, checkSizeLoad]);
    var srcListFinal = useMemo(function () { var _a; return (((_a = (isPrint ? getPostWithoutOriginals(post) : post)) === null || _a === void 0 ? void 0 : _a.attachments) || srcList); }, [post, srcList, isPrint]);
    // const commentController = useMemo(() => {
    //   return (
    //     <CommentViewController postEntityId={post?.postId} />
    //   )
    // } , [post])
    var captionMaxLength = 100;
    useEffect(function () {
        if (isUnsizedImages(srcListFinal)) {
            setCheckSizeLoad(true);
            fixUnsizedImages(srcListFinal || [])
                .then(function (r) {
                setListWithSizes(r || []);
                setCheckSizeLoad(false);
            });
        }
        else {
            setListWithSizes(srcListFinal);
        }
    }, [srcListFinal]);
    var handleButtonClick = useCallback(function (position) {
        var currentEditedSlide = editedSlideRef.current;
        if (!currentEditedSlide) {
            setEditingText(true);
            return;
        }
        onSlideTextChange(currentEditedSlide, 'updatePosition', position);
        setPosition(position);
    }, [editedSlide, onSlideTextChange, srcListFinal]);
    var handleSlideEditToggle = function (id, value, textPosition) {
        if (value === true) {
            editedSlideRef.current = id;
            setEditedSlide(id);
            setPosition(textPosition || 'bottom');
        }
        else {
            editedSlideRef.current = null;
            setEditedSlide(null);
            setPosition(null);
        }
    };
    var controls = useMemo(function () {
        if (controlsPlacer) {
            return createPortal(React.createElement(React.Fragment, null,
                !!editedSlide && (React.createElement(React.Fragment, null,
                    React.createElement(HintTooltip, { z: 4, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_top') },
                        React.createElement(AddTextTop, { active: position === 'top', onClick: function () { return handleButtonClick('top'); } })),
                    React.createElement(HintTooltip, { z: 3, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_center') },
                        React.createElement(AddTextCenter, { active: position === 'center', onClick: function () { return handleButtonClick('center'); } })),
                    React.createElement(HintTooltip, { z: 2, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_bottom') },
                        React.createElement(AddTextBottom, { active: position === 'bottom', onClick: function () { return handleButtonClick('bottom'); } })))),
                !editedSlide && (React.createElement(HintTooltip, { z: 1, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_under') },
                    React.createElement(AddTextCaption, { active: position === 'caption-bottom', onClick: onCaptionEdit })))), controlsPlacer);
        }
    }, [controlsPlacer, position, editedSlide, handleButtonClick, t, onCaptionEdit]);
    if (!(listWithSizes === null || listWithSizes === void 0 ? void 0 : listWithSizes.length) && !isEditable) {
        return null;
    }
    if (isPrint && printType !== 'magazine')
        return React.createElement(TwoPicturesPrintImageWrap, { style: { backgroundColor: printBg }, withoutCaption: !(post === null || post === void 0 ? void 0 : post.caption), isPrint: true },
            React.createElement(MultipleColumn, { srcList: listWithSizes, isEditable: isEditable && !post, onChange: onChange, onSlideTextChange: onSlideTextChange, onRatioError: onRatioError, onSlideEditToggle: handleSlideEditToggle, position: position, editedSlide: editedSlide, onChangeImage: onChangeImage, captionMaxLength: captionMaxLength, fileRef: fileRef }),
            (post === null || post === void 0 ? void 0 : post.caption) && (React.createElement(CaptionBlock, { className: 'longread-caption-block', colorStyle: colorStyle },
                React.createElement(CaptionMarkdownText, { rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks(post === null || post === void 0 ? void 0 : post.caption)))));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { position: 'relative' } },
            isLoading && (React.createElement(React.Fragment, null, isMobile || (post === null || post === void 0 ? void 0 : post.postId) === 'updating' ? (React.createElement(MobileLoaderWrapper, { colorStyle: colorStyle },
                React.createElement(LoaderModal, { placeholder: t('modal.loader.isLoading') }))) : (React.createElement(LoaderProgressBar, null)))),
            React.createElement(OverlayBoundary, { className: 'white-post-block', isLoadingPost: isLoading },
                React.createElement(GeneralEditorOverlay, { isEditable: isEditable, isLoading: isLoading, withoutDrag: isFeed, post: post, dragHandleProps: dragHandleProps }),
                controls,
                React.createElement(MultipleColumn, { srcList: listWithSizes, isEditable: isEditable && !post, onChange: onChange, onSlideTextChange: onSlideTextChange, onRatioError: onRatioError, onSlideEditToggle: handleSlideEditToggle, position: position, editedSlide: editedSlide, onChangeImage: onChangeImage, captionMaxLength: captionMaxLength, fileRef: fileRef }))),
        (post === null || post === void 0 ? void 0 : post.caption) && (React.createElement(CaptionBlock, { className: 'longread-caption-block', colorStyle: colorStyle },
            React.createElement(CaptionMarkdownText, { rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks(post === null || post === void 0 ? void 0 : post.caption))))));
};
export default TwoPicturesBlock;
//# sourceMappingURL=TwoPicturesBlock.js.map